import axios from "axios";
import { useEffect, useState } from "react";
import authServices from "../../../../services/authServices";
import dataProvider from "../../../../services/dataProvider";
import DashboardActivityTable from "./dashboard-activity-table";
import DashboardChart from "./dashboard-chart";
import DashboardIncompleteTaskTable from "./dashboard-incomplete-tasks-table";
import DashboardSubmittedFormsTable from "./dashboard-submitted-forms-table";
import DashboardTaskTable from "./dashboard-task-table";

const DashboardOverview = () => {
    const [incompleteTaskData, setIncompleteTaskData] = useState([]);
    const [upcommingTaskData, setUpcommingTaskData] = useState([]);
    const [activityData, setActivityData] = useState([]);
    const [submittedFormData, setSubmittedFormData] = useState([]);

    const [fetching, setFetching] = useState(true);
    const [fetchingTasks, setFetchingTasks] = useState(false);

    function setTaskData(tasks) {
        let incompleteTasks = [];
        let upcommingTasks = [];

        let now = Date.now();

        tasks.forEach((task) => {
            let deadline = task.deadline._seconds * 1000;
            if (deadline <= now && task.isCompleted === false) {
                incompleteTasks.push(task);
            } else if(deadline >= now) {
                // console.log(now,deadline,task)
                upcommingTasks.push(task);
            }
        });

        setIncompleteTaskData(incompleteTasks);
        setUpcommingTaskData(upcommingTasks);
    }

    useEffect(() => {
        setFetchingTasks(true);
        setFetching(true);

        var config = {
            method: "get",
            url: dataProvider.baseUrl + "tasks-getTasksByOrgId",
            headers: {
                token: authServices.getToken(),
                orgid: authServices.getOrgId(),
            },
        };

        axios(config)
            .then(function (response) {
                setFetchingTasks(false);
                setFetching(false);
                //console.log("Tasks", response.data);
                setTaskData(response.data);
            })
            .catch((error) => {
                setFetchingTasks(false);
                setFetching(false);
                console.error(error);
            });
    }, []);

    return (
        <div id="dashboard-overview">
            {fetching ? (
                <div className="container-fluid p-3">
                    <div className="card border-0 p-5">
                        <div className="d-flex align-items-center justify-content-center">
                            <div className="me-3">Fetching Data</div>
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div>
                    <div className="d-lg-flex w-100 position-relative" style={{overflowX:"hidden"}}>
                        <div style={{flex:"7 0"}}>
                            <DashboardChart />
                        </div>
                        <div className="" style={{flex:"4 0"}}>
                            <DashboardIncompleteTaskTable data={incompleteTaskData} isLoading={fetchingTasks} />
                        </div>
                    </div>
                
                    <DashboardTaskTable data={upcommingTaskData} isLoading={fetchingTasks} />
                    <DashboardActivityTable data={activityData} />
                    <DashboardSubmittedFormsTable data={submittedFormData} />
                </div>
            )}
        </div>
    );
};

export default DashboardOverview;
